import { AnyAction } from '@reduxjs/toolkit';

/* TODO */
/* const setLoading: ActionCreatorWithoutPayload
() => {
    payload: undefined;
    type: string;
}
Calling this redux#ActionCreator will return a PayloadAction of type T with a payload of undefined */

export const loading = <S extends { loading: boolean }, A extends AnyAction>(
  state: S,
  action: A,
): S | void => {
  state.loading = action.payload;
};

export const data = <S extends { data: [] }, A extends AnyAction>(
  state: S,
  action: A,
): S | void => {
  state.data = action.payload;
};
